/**
 * URL Building Utilities
 *
 * Utility for safely building redirect URLs with tracking parameters.
 */

/**
 * Builds a redirect URL with standard tracking parameters
 *
 * @param baseUrl - The base URL to build upon
 * @param additionalParams - Optional additional query parameters
 * @returns The complete URL with tracking parameters, or original URL on failure
 */
export function buildRedirectUrlWithTracking(
  baseUrl: string,
  additionalParams?: Record<string, string>,
): string {
  try {
    const url = new URL(baseUrl);

    // Standard tracking parameters
    url.searchParams.set('t', new Date().toISOString());
    url.searchParams.set('uniqueId', Math.random().toString(36).substring(7));

    // Add any additional parameters
    if (additionalParams) {
      Object.entries(additionalParams).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });
    }

    return url.toString();
  } catch {
    // Return original URL as safe fallback
    return baseUrl;
  }
}
